<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc"><h2>Contents</h2>
<ol class="bbb-rw" epub:type="list"><li><a href="#/Text/cover">Cover</a></li>
<li><a href="#/Text/s001BookTitlePage01">Title Page</a></li>
<li><a href="#/Text/s002Copyright01">Copyright</a></li>
<li>
<a href="#/Text/s004Part001">All the Pretty Little Horses</a>
<ol epub:type="list"><li><a href="#/Text/s006Chapter001">Chapter 1: What We Lost</a></li>
<li><a href="#/Text/s008Chapter003">Chapter 2: What We Found</a></li>
<li><a href="#/Text/s010Chapter005">Chapter 3: What We Gave Away</a></li>
<li><a href="#/Text/s012Chapter007">Chapter 4: What We Stole</a></li>
</ol></li>
<li><a href="#/Text/s015Part02">Extras</a>
<ol epub:type="list"><li><a href="#/Text/s016AboutTheAuthor01">Meet the Author</a></li>
<li><a href="#/Text/s017AdCard01">By Mira Grant</a></li>
<li><a href="#/Text/s018Teaser01">A Preview of "Into the Drowning Deep"</a></li>
</ol></li>
<li><a href="#/Text/s022BackAd01">About Orbit Short Fiction</a></li>
<li><a href="#/Text/s023Appendix01">Newsletters</a></li>
</ol></nav>
<nav class="ccc-rw" epub:type="landmarks"><h2>
    Navigation
   </h2>
<ol epub:type="list"><li>
<a epub:type="bodymatter" href="#/Text/s005Epigraph001#Epigraph1">
      Begin Reading
     </a>
</li>
<li>
<a epub:type="toc" href="#/Text/TOC">
      Table of Contents
     </a>
</li>
</ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?0783c342